import {Button, Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

const EmptyStateContainer = styled(Box)`
	background-color: ${({theme}) => theme.palette.grey[50]};
	border-radius: 8px;
	padding: 48px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
`;

const IconContainer = styled(Box)`
	background-color: ${({theme}) => theme.palette.primary.main}19; /* 19 = 10% opacity in hex */
	border-radius: 60px;
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
`;

const StyledTitle = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.15px;
	text-align: center;
	line-height: 1.6;
`;

const StyledDescription = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	line-height: 1.5;
	max-width: 918px;
`;

const StyledButton = styled(Button)`
	border-radius: 24px;
	padding: 8px 22px;
	font-size: 15px;
	font-weight: 600;
	line-height: 26px;
	letter-spacing: 0.46px;
	text-transform: none;
	min-width: 200px;
`;

export {EmptyStateContainer, IconContainer, StyledTitle, StyledDescription, StyledButton};
